// extracted by mini-css-extract-plugin
export default {"button":"Button_button__wiIYs","button_primary":"Button_button_primary__B4tw-","button_secondary":"Button_button_secondary__e9Rn-"};